import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SidebarService } from '../sidebar.service';

/* export interface Sklop {
  value: string;
  viewValue: string;
}
*/

/* export interface Spremenljivka {
  value: string;
  viewValue: string;
} */

export interface Regija {
  value: string;
  viewValue: string;
}

/* export interface TempTal{
  value: string;
  viewValue: string;
}; */

/* export interface Feno{
  value: string;
  viewValue: string;
}; */

/* export interface RastDoba{
  value: string;
  viewValue: string;
}; */

export interface Pozeba {
  value: string;
  viewValue: string;
};

export interface PostajeTla {
  value: string;
  viewValue: string;
}

/* export interface Postaje {
  value: string;
  viewValue: string;
} */

export interface Porečje {
  value: string;
  viewValue: string;
}

export interface HidroPorecje{
  value: string;
  viewValue: string;
} 

export interface SPI {
  value: string;
  viewValue: string;
}

export interface SPEI {
  value: string;
  viewValue: string;
}

export interface SifraPostaje {
  value: string;
  viewValue: string;
}

export interface Scenarij {
  value: string;
  viewValue: string;
}

export interface VodnoTelo{
  value: string;
  viewValue: string;
} 

export interface NadmorskaVisina{
  value: string;
  viewValue: string;
} 

@Component({
  selector: 'app-filter1',
  templateUrl: './filter1.component.html',
  styleUrls: ['./filter1.component.css']
})
export class Filter1Component implements OnInit {

  selected1 = undefined;
  selected2 = undefined;
  selected3 = undefined;
  selected3a = undefined;
  selected3b = undefined;
  selected3c = undefined;
  selected4 = undefined;
  selected5 = undefined;
  selected6 = undefined;
  selected6a = undefined;
  selected8 = undefined;
  selected11 = undefined;
  selected11c = undefined;
  selected12 = undefined;
  selected13 = undefined;


  /* izbira: Sklop[] = [
    {value: 'temp-0', viewValue: 'Temperatura'},
    {value: 'pad-1', viewValue: 'Padavine'},
    {value: 'vodBil-2', viewValue: 'Vodna bilanca'},
    {value: 'hidrSpr-3', viewValue: 'Hidrološke spremenljivke'}
  ];

  spremenljivka: Spremenljivka[] = [
    {value: 'spr-0', viewValue: 'Povprečna temperatura'},
    {value: 'spr-1', viewValue: 'Najvišja temperatura'},
    {value: 'spr-2', viewValue: 'Najnižja temperatura'},
    {value: 'spr-4', viewValue: 'Temperaturne razmere za rast rastlin'},
    {value: 'spr-5', viewValue: 'Višina padavin'},
    {value: 'spr-9', viewValue: 'Referenčna evapotranspiracija'},
    {value: 'spr-14', viewValue: 'Srednji pretoki'},
    {value: 'spr-15', viewValue: 'Veliki pretoki'},
    {value: 'spr-16', viewValue: 'Mali pretoki'}
  ];
  */


  /* tempTal: TempTal[] = [
    {value: 'tmpTal-0', viewValue: 'Povprečna temperatura tal na globini 5 cm (april-junij)'},
    {value: 'tmpTal-1', viewValue: 'Povprečna temperatura tal na globini 10 cm (april-junij)'},
    {value: 'tmpTal-2', viewValue: 'Povprečna temperatura tal na globini 20 cm (april-junij)'},
    {value: 'tmpTal-3', viewValue: 'Povprečna temperatura tal na globini 30 cm (april-junij)'},
    {value: 'tmpTal-4', viewValue: 'Povprečna temperatura tal na globini 5 cm (julij-september)'},
    {value: 'tmpTal-5', viewValue: 'Povprečna temperatura tal na globini 10 cm (julij-september)'},
    {value: 'tmpTal-6', viewValue: 'Povprečna temperatura tal na globini 20 cm (julij-september)'},
    {value: 'tmpTal-7', viewValue: 'Povprečna temperatura tal na globini 30 cm (julij-september)'}
  ]; */

  /* feno: Feno[] = [
    {value: 'tmpRaz-2', viewValue: 'Olistanje divjega kostanja'},
    {value: 'tmpRaz-3', viewValue: 'Olistanje bukve'},
    {value: 'tmpRaz-4', viewValue: 'Olistanje lipe'}
  ]; */

  /* rastDoba: RastDoba[] = [
    
  ]; */

  /* pozeba: Pozeba[] = [
    
  ]; */

  regija: Regija[] = [
    { value: 'reg-0', viewValue: 'Slovenija' },
    { value: 'reg-1', viewValue: 'Posočje' },
    { value: 'reg-2', viewValue: 'Osrednja' },
    { value: 'reg-3', viewValue: 'Severovzhod' },
    { value: 'reg-4', viewValue: 'Jugozahod' },
    { value: 'reg-5', viewValue: 'Visokogorje' },
    { value: 'reg-6', viewValue: 'Prehodna' }
  ];

  name: string;

  public izbira = [
    { value: 1, viewValue: 'Temperatura' },
    { value: 2, viewValue: 'Padavine' },
    { value: 3, viewValue: 'Sneg' },
    { value: 4, viewValue: 'Sončno obsevanje' },
    { value: 5, viewValue: 'Veter' },
    { value: 6, viewValue: 'Vodna bilanca' },
    { value: 7, viewValue: 'Hidrološke spremenljivke' },
    { value: 8, viewValue: 'Kazalniki suše' },
    { value: 9, viewValue: 'Raba energije za ogrevanje in hlajenje' }
    //{ value: 10, viewValue: 'Hidropotencial' }
  ];

  porecje: Porečje[] = [
    { value: 'por-0', viewValue: 'Dravinja - Kras' },
    { value: 'por-1', viewValue: 'Kraška Ljubljanica - Mura' },
    { value: 'por-2', viewValue: 'Pesnica - Sotla' },
    { value: 'por-3', viewValue: 'Spodnja Drava - Zgornja Drava' },
    { value: 'por-4', viewValue: 'Zgornja Sava - Zgornja Soča' }
  ];

  spi: SPI[] = [
    {value: 'spi-0', viewValue: 'SPI-1'},
    {value: 'spi-2', viewValue: 'SPI-3'},
    {value: 'spi-6', viewValue: 'SPI-6'}
  ];

  spei: SPEI[] = [
    {value: 'spei-0', viewValue: 'SPEI-1'},
    {value: 'spei-2', viewValue: 'SPEI-3'},
    {value: 'spei-6', viewValue: 'SPEI-6'}
  ];

  sifraPostaje: SifraPostaje[] = [
    { value: 'sifra-0', viewValue: '2250 - 2754' },
    { value: 'sifra-1', viewValue: '2880 - 3570' },
    { value: 'sifra-2', viewValue: '3660 - 4200' },
    { value: 'sifra-3', viewValue: '4230 - 4770' },
    { value: 'sifra-4', viewValue: '4280 - 6200' },
    { value: 'sifra-5', viewValue: '6210 - 7060' },
    { value: 'sifra-6', viewValue: '7160 - 8500' },
    { value: 'sifra-7', viewValue: '8565 - 9050' },
  ];

  scenarij: Scenarij[] = [
    {value: 'scenarij-0', viewValue: 'RCP2.6'},
    {value: 'scenarij-1', viewValue: 'RCP4.5'},
    {value: 'scenarij-2', viewValue: 'RCP8.5'}
  ];

  vodnoTelo: VodnoTelo[] =[
   {value: 'vodnotelo-0', viewValue: 'Savska kotlina in Ljubljansko Barje'},
   {value: 'vodnotelo-1', viewValue: 'Savinjska kotlina'},
   {value: 'vodnotelo-2', viewValue: 'Krška kotlina'},
   {value: 'vodnotelo-3', viewValue: 'Julijske Alpe v porečju Save'},
   {value: 'vodnotelo-4', viewValue: 'Karavanke'},
   {value: 'vodnotelo-5', viewValue: 'Kamniško-Savinjske Alpe'},
   {value: 'vodnotelo-6', viewValue: 'Cerkljansko, Škofjeloško in Polhograjsko hribovje'},
   {value: 'vodnotelo-7', viewValue: 'Posavsko hribovje do osrednje Sotle'},
   {value: 'vodnotelo-8', viewValue: 'Spodnji del Savinje do Sotle'},
   {value: 'vodnotelo-9', viewValue: 'Kraška Ljubljanica'},
   {value: 'vodnotelo-10', viewValue: 'Dolenjski kras'},
   {value: 'vodnotelo-11', viewValue: 'Dravska kotlina'},
   {value: 'vodnotelo-12', viewValue: 'Vzhodne Alpe'},
   {value: 'vodnotelo-13', viewValue: 'Haloze in Dravinjske gorice'},
   {value: 'vodnotelo-14', viewValue: 'Zahodne Slovenske gorice'},
   {value: 'vodnotelo-15', viewValue: 'Murska kotlina'},
   {value: 'vodnotelo-16', viewValue: 'Vzhodne Slovenske gorice'},
   {value: 'vodnotelo-17', viewValue: 'Goričko'},
   {value: 'vodnotelo-18', viewValue: 'Obala in Kras z Brkini'},
   {value: 'vodnotelo-19', viewValue: 'Julijske Alpe v porečju Soče'},
   {value: 'vodnotelo-20', viewValue: 'Goriška brda in Trnovsko-Banjška planota'}
  ];
  
  nadmorskaVisina: NadmorskaVisina[] =[
   {value: 'nadmorskavisina-0', viewValue: '0-300 m'},
   {value: 'nadmorskavisina-1', viewValue: '301-600 m'},
   {value: 'nadmorskavisina-2', viewValue: '601-900 m'},
   {value: 'nadmorskavisina-3', viewValue: '901-1200 m'},
   {value: 'nadmorskavisina-4', viewValue: '1201-1500 m'},
   {value: 'nadmorskavisina-5', viewValue: '1501-1800 m'}, 
   {value: 'nadmorskavisina-6', viewValue: '1801-2900 m'}, 
   {value: 'nadmorskavisina-7', viewValue: 'vse višine'}
  ]; 

  hidroPorecje: HidroPorecje[] = [
    {value: 'hidroPorecje-0', viewValue: 'Pomurje'},
    {value: 'hidroPorecje-1', viewValue: 'Podravje'},    
    {value: 'hidroPorecje-2', viewValue: 'Sava'},
    {value: 'hidroPorecje-3', viewValue: 'Pritoki Save brez Savinje, 1. del'},
    {value: 'hidroPorecje-4', viewValue: 'Pritoki Save brez Savinje, 2. del'},
    {value: 'hidroPorecje-5', viewValue: 'Savinja s pritoki'},
    {value: 'hidroPorecje-6', viewValue: 'Posočje'},
    {value: 'hidroPorecje-7', viewValue: 'Povodje Jadranskega morja'}
   ]; 

  /* postajeTla: PostajeTla[] = [
    { value: 'post-0', viewValue: 'Bilje'},
    { value: 'post-1', viewValue: 'Celje'},
    { value: 'post-2', viewValue: 'Ljubljana'},
    { value: 'post-3', viewValue: 'Novo mesto'},
    { value: 'post-4', viewValue: 'Maribor'},
    { value: 'post-5', viewValue: 'Murska Sobota'},
    { value: 'post-6', viewValue: 'Šmartno pri Slovenj Gradcu'} 
  ]; */

  /*  postaje: Postaje[] = [
     { value: 'post-0', viewValue: 'Bilje'},
     { value: 'post-1', viewValue: 'Celje'},
     { value: 'post-2', viewValue: 'Lesce'},
     { value: 'post-3', viewValue: 'Ljubljana'},
     { value: 'post-4', viewValue: 'Novo mesto'},
     { value: 'post-5', viewValue: 'Portorož'},
     { value: 'post-6', viewValue: 'Slovenske Konjice'},
     { value: 'post-7', viewValue: 'Starše'},
     { value: 'post-8', viewValue: 'Veliki Dolenci'}
   ]; */

  defualtOption = null;
  public spremenljivka = [];
  /* private porecje = []; */
  private agroSpremenljivka = [];
  private agroSprVse = [];
  private postaje = [];
  private tempPrag = [];
  private regija1 = [];
 
  /* private spremenljivka = [
    {value: 'spr-0', viewValue: 'Povprečna temperatura'},
    {value: 'spr-1', viewValue: 'Najvišja temperatura'},
    {value: 'spr-2', viewValue: 'Najnižja temperatura'},
    {value: 'spr-4', viewValue: 'Temperaturne razmere za rast rastlin'},
    {value: 'spr-5', viewValue: 'Višina padavin'},
    {value: 'spr-9', viewValue: 'Referenčna evapotranspiracija'},
    {value: 'spr-14', viewValue: 'Srednji pretoki'},
    {value: 'spr-15', viewValue: 'Veliki pretoki'},
    {value: 'spr-16', viewValue: 'Mali pretoki'}
  ]; */

  selectDisabled3 = true;
  selectDisabled3a = true;
  selectDisabled3b = true;
  selectDisabled3c = true;
  selectDisabled4 = true;
  selectDisabled5 = true;
  selectDisabled6 = true;
  selectDisabled6a = true;
  selectDisabled8 = true;
  selectDisabled11 = true;
  selectDisabled11c = true;
  selectDisabled12 = true;
  selectDisabled13 = true;
  hidden3 = false;
  hidden3a = false;
  hidden3b = false;
  hidden3c = false;
  hidden4 = false;
  hidden5 = false;
  hidden6 = false;
  hidden6a = false;
  hidden8 = false;
  hidden11 = false;
  hidden11c = false;
  hidden12 = false;
  hidden13 = false;

  firstDropDownChanged(viewValue: any) {
    const obj = this.izbira[viewValue];
    console.log(obj);

    if (!obj) return;

    this.selected2 = undefined;
    this.selected3 = undefined;
    this.selected3a = undefined;
    this.selected3b = undefined;
    this.selected3c = undefined;
    this.selected4 = undefined;
    this.selected5 = undefined;
    this.selected6 = undefined;
    this.selected6a = undefined;
    this.selected8 = undefined;
    this.selected11 = undefined;
    this.selected11c = undefined;
    this.selected12 = undefined;
    this.selected13 = undefined;

    if (obj.value == 1) {
      this.spremenljivka = [
        { value: 'spr-0', viewValue: 'Povprečna temperatura' },
        { value: 'spr-1', viewValue: 'Najvišja temperatura' },
        { value: 'spr-2', viewValue: 'Najnižja temperatura' },
        { value: 'spr-4', viewValue: 'Temperaturne razmere za rast rastlin' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled6a = true;
      this.selectDisabled8 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.selectDisabled13 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden6a = false;
      this.hidden8 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.hidden13 = false;
    }
    else if (obj.value == 2) {
      this.spremenljivka = [
        { value: 'spr-5', viewValue: 'Višina padavin' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled6a = true;
      this.selectDisabled8 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.selectDisabled13 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden6a = false;
      this.hidden8 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.hidden13 = false;
    }
    else if (obj.value == 3) {
      this.spremenljivka = [
        { value: 'spr-31', viewValue: 'Število dni s snežno odejo' },
        { value: 'spr-32', viewValue: 'Količina vode v novozapadlem snegu' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled6a = true;
      this.selectDisabled8 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.selectDisabled13 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden6a = false;
      this.hidden8 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.hidden13 = false;

    }
    else if (obj.value == 4) {
      this.spremenljivka = [
        { value: 'spr-41', viewValue: 'Globalni obsev' },
        { value: 'spr-42', viewValue: 'Trajanje sončnega obsevanja' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled6a = true;
      this.selectDisabled8 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.selectDisabled13 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden6a = false;
      this.hidden8 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.hidden13 = false;
    }
    else if (obj.value == 5) {
      this.spremenljivka = [
        { value: 'spr-51', viewValue: 'Povprečna hitrost vetra' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled6a = true;
      this.selectDisabled8 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.selectDisabled13 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden6a = false;
      this.hidden8 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.hidden13 = false;
    }
    else if (obj.value == 6) {
      this.spremenljivka = [
        { value: 'spr-9', viewValue: 'Referenčna evapotranspiracija' },
        { value: 'spr-62', viewValue: 'Skupni odtok' },
        { value: 'spr-63', viewValue: 'Napajanje podzemnih voda' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled6a = true;
      this.selectDisabled8 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.selectDisabled13 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden6a = false;
      this.hidden8 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.hidden13 = false;
    }
    else if (obj.value == 7) {
      this.spremenljivka = [
        { value: 'spr-14', viewValue: 'Srednji pretoki' },
        { value: 'spr-15', viewValue: 'Veliki pretoki' },
        { value: 'spr-16', viewValue: 'Mali pretoki' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled6a = true;
      this.selectDisabled8 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.selectDisabled13 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden6a = false;
      this.hidden8 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.hidden13 = false;
    }
    else if (obj.value == 8) {
      this.spremenljivka = [
        { value: 'spr-81', viewValue: 'SPI' },
        { value: 'spr-82', viewValue: 'SPEI' },
        { value: 'spr-83', viewValue: 'EDDI' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled6a = true;
      this.selectDisabled8 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.selectDisabled13 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden6a = false;
      this.hidden8 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.hidden13 = false;
    }
    else if (obj.value == 9) {
      this.spremenljivka = [
        { value: 'spr-91', viewValue: 'Temperaturni primanjkljaj' },
        { value: 'spr-92', viewValue: 'Temperaturni presežek' },
        { value: 'spr-93', viewValue: 'Kurilna sezona' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled6a = true;
      this.selectDisabled8 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.selectDisabled13 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden6a = false;
      this.hidden8 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.hidden13 = false;
    }
    else if (obj.value == 10) {
      this.spremenljivka = [
        { value: 'spr-101', viewValue: 'Pretok' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled6a = true;
      this.selectDisabled8 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.selectDisabled13 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden6a = false;
      this.hidden8 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.hidden13 = false;
    }

    this.eventClicked1.emit(this.selected1);
    this.eventClicked2.emit(this.selected2);
    this.eventClicked3.emit(this.selected3);
    this.eventClicked3a.emit(this.selected3a);
    this.eventClicked3b.emit(this.selected3b);
    this.eventClicked3c.emit(this.selected3c);
    this.eventClicked4.emit(this.selected4);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked6.emit(this.selected6);
    this.eventClicked6a.emit(this.selected6a);
    this.eventClicked8.emit(this.selected8);
    this.eventClicked11.emit(this.selected11);
    this.eventClicked11c.emit(this.selected11c);
    this.eventClicked12.emit(this.selected12);
    this.eventClicked13.emit(this.selected13);

  }

  secondDropDownChanged(value: any) {
    console.log(value);

    if (value == 'spr-0' || value == 'spr-1' || value == 'spr-2' || value == 'spr-5' || value == 'spr-9' || value == 'spr-83' || value == 'spr-51' || value == 'spr-42' || value == 'spr-41') {
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = false;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = true;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.regija = this.regija;
      this.selected3 = undefined;      
      this.selected3a = undefined;      
      this.selected3b = undefined;      
      this.selected3c = undefined;      
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected11 = undefined;
      this.selected11c = undefined;
      this.selected12 = undefined;
    }
    else if (value == 'spr-81') {
      this.spi = this.spi;
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = false;
      this.selectDisabled3c = true;
      this.selectDisabled4 = false;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = true;
      this.hidden3c = false;
      this.hidden4 = true;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.regija = this.regija;
      this.selected3 = undefined;
      this.selected3a = undefined;
      this.selected3b = undefined;
      this.selected3c = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected11 = undefined;
      this.selected11c = undefined;
      this.selected12 = undefined;
    }
    else if (value == 'spr-82') {
      this.spei = this.spei;
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = false;
      this.selectDisabled4 = false;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = true;
      this.hidden4 = true;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.regija = this.regija;
      this.selected3 = undefined;
      this.selected3a = undefined;
      this.selected3b = undefined;
      this.selected3c = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected11 = undefined;
      this.selected11c = undefined;
      this.selected12 = undefined;
    }
    else if (value == 'spr-91') {
      this.tempPrag = [
        {value: 'tempPrag-0', viewValue: 'Prag 12 °C'}
      ]
      this.selectDisabled3 = true;
      this.selectDisabled3a = false;
      this.selectDisabled4 = false;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden3a = true;
      this.hidden4 = true;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.regija = this.regija;
      this.selected3 = undefined;
      this.selected3a = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected11 = undefined;
      this.selected11c = undefined;
      this.selected12 = undefined;
    }
    else if (value == 'spr-92') {
      this.tempPrag = [
        {value: 'tempPrag-1', viewValue: 'Prag 18 °C'},
        {value: 'tempPrag-2', viewValue: 'Prag 21 °C'},
        {value: 'tempPrag-3', viewValue: 'Prag 23 °C'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled3a = false;
      this.selectDisabled4 = false;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden3a = true;
      this.hidden4 = true;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.regija = this.regija;
      this.selected3 = undefined;
      this.selected3a = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected11 = undefined;
      this.selected11c = undefined;
      this.selected12 = undefined;
    }
    else if (value == 'spr-4') {
      this.agroSpremenljivka = [
        { value: 'agro-1', viewValue: 'Temperatura tal' },
        { value: 'agro-2', viewValue: 'Fenološke faze' },
        { value: 'agro-3', viewValue: 'Rastna doba' },
        { value: 'agro-4', viewValue: 'Pozeba' },
      ];
      this.selectDisabled3 = false;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = true;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.selected4 = undefined;
      this.selected11 = undefined;
      this.selected11c = undefined;
      this.selected12 = undefined;
    }
    else if (value == 'spr-62') {
      /* this.porecje = [
        { value: 'por-0', viewValue: 'Dravinja - Kras' },
        { value: 'por-1', viewValue: 'Kraška Ljubljanica - Mura' },
        { value: 'por-2', viewValue: 'Pesnica - Sotla' },
        { value: 'por-3', viewValue: 'Spodnja Drava - Zgornja Drava' },
        { value: 'por-4', viewValue: 'Zgornja Sava - Zgornja Soča' }
      ]; */
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled11 = false;
      this.selectDisabled11c = false;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden11 = true;
      this.hidden11c = false;
      this.hidden12 = false;
      this.porecje = this.porecje;
      this.selected4 = undefined;
      this.selected11c = undefined;
      this.selected12 = undefined;
    }

    else if (value == 'spr-63') {
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = false;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = true;
      this.vodnoTelo = this.vodnoTelo;
      this.selected4 = undefined;
      this.selected11 = undefined;
      this.selected11c = undefined;
    }

    else if (value == 'spr-101') {
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled6a = false;
      this.selectDisabled8 = false;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden6a = true;
      this.hidden8 = true;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
    }

    else if (value == 'spr-31'|| value == 'spr-32' ){
      this.selectDisabled3 = true;
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.selectDisabled13 = false;
      this.hidden3 = false;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.hidden13 = true;
      this.selected3 = undefined;      
      this.selected3a = undefined;      
      this.selected3b = undefined;      
      this.selected3c = undefined;      
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected11 = undefined;
      this.selected11c = undefined;
      this.selected12 = undefined;
    } 

    else if (value == 'spr-14'|| value == 'spr-15'|| value == 'spr-16') {
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = false;
      this.selectDisabled12 = true;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden11 = false;
      this.hidden11c = true;
      this.hidden12 = false;
      this.selected3 = undefined;
      this.selected3a = undefined;
      this.selected3b = undefined;
      this.selected3c = undefined;
      this.selected4 = undefined;
      this.selected6 = undefined;
      this.selected6a = undefined;
      this.selected8 = undefined;
      this.selected11 = undefined;
      this.selected12 = undefined;
    }

    else {
      this.selectDisabled3a = true;
      this.selectDisabled3b = true;
      this.selectDisabled3c = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3a = false;
      this.hidden3b = false;
      this.hidden3c = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden11 = false;
      this.hidden11c = false;
      this.hidden12 = false;
      this.selected3 = undefined;
      this.selected3a = undefined;
      this.selected3b = undefined;
      this.selected3c = undefined;
      this.selected4 = undefined;
      this.selected6 = undefined;
      this.selected6a = undefined;
      this.selected8 = undefined;
      this.selected11 = undefined;
      this.selected11c = undefined;
      this.selected12 = undefined;
    }

    this.eventClicked2.emit(this.selected2);
    this.eventClicked3.emit(this.selected3);
    this.eventClicked3a.emit(this.selected3a);
    this.eventClicked3b.emit(this.selected3b);
    this.eventClicked3c.emit(this.selected3c);
    this.eventClicked4.emit(this.selected4);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked6.emit(this.selected6);
    this.eventClicked6a.emit(this.selected6a);
    this.eventClicked8.emit(this.selected8);
    this.eventClicked11.emit(this.selected11);
    this.eventClicked11c.emit(this.selected11c);
    this.eventClicked12.emit(this.selected12);

  }

  thirdDropDownChanged(value: any) {
    console.log(value);
    if (value == 'agro-1') {
      this.agroSprVse = [
        { value: 'tmpTal-0', viewValue: 'Povprečna temperatura tal na globini 5 cm (april-junij)' },
        { value: 'tmpTal-1', viewValue: 'Povprečna temperatura tal na globini 10 cm (april-junij)' },
        { value: 'tmpTal-2', viewValue: 'Povprečna temperatura tal na globini 20 cm (april-junij)' },
        { value: 'tmpTal-3', viewValue: 'Povprečna temperatura tal na globini 30 cm (april-junij)' },
        { value: 'tmpTal-4', viewValue: 'Povprečna temperatura tal na globini 5 cm (julij-september)' },
        { value: 'tmpTal-5', viewValue: 'Povprečna temperatura tal na globini 10 cm (julij-september)' },
        { value: 'tmpTal-6', viewValue: 'Povprečna temperatura tal na globini 20 cm (julij-september)' },
        { value: 'tmpTal-7', viewValue: 'Povprečna temperatura tal na globini 30 cm (julij-september)' }
      ];
      this.selectDisabled4 = true;
      this.selectDisabled5 = false;
      this.selectDisabled6 = true;
      this.hidden4 = false;
      this.hidden5 = true;
      this.hidden6 = false;
      this.selected5 = undefined;
      this.selected6 = undefined;
    }
    else if (value == 'agro-2') {
      this.agroSprVse = [
        { value: 'feno-0', viewValue: 'Olistanje divjega kostanja' },
        { value: 'feno-1', viewValue: 'Olistanje bukve' },
        { value: 'feno-2', viewValue: 'Olistanje lipe' }
      ];
      this.selectDisabled4 = true;
      this.selectDisabled5 = false;
      this.selectDisabled6 = true;
      this.hidden4 = false;
      this.hidden5 = true;
      this.hidden6 = false;
      this.selected5 = undefined;
      this.selected6 = undefined;
    }
    else if (value == 'agro-3') {
      this.agroSprVse = [
        { value: 'rastDoba-0', viewValue: 'Začetek rastne dobe za temperaturni prag 5 °C' },
        { value: 'rastDoba-1', viewValue: 'Začetek rastne dobe za temperaturni prag 10 °C' },
        { value: 'rastDoba-2', viewValue: 'Dolžina rastne dobe za temperaturni prag 5 °C' },
        { value: 'rastDoba-3', viewValue: 'Dolžina rastne dobe za temperaturni prag 10 °C' },
        { value: 'rastDoba-4', viewValue: 'Konec rastne dobe za temperaturni prag 5 °C' },
        { value: 'rastDoba-5', viewValue: 'Konec rastne dobe za temperaturni prag 10 °C' }
      ];
      this.selectDisabled4 = true;
      this.selectDisabled5 = false;
      this.selectDisabled6 = true;
      this.hidden4 = false;
      this.hidden5 = true;
      this.hidden6 = false;
      this.selected5 = undefined;
      this.selected6 = undefined;
    }
    else {
      this.agroSprVse = [
        { value: 'pozeba-0', viewValue: 'Zadnja spomladanska pozeba (0 °C)' },
        { value: 'pozeba-1', viewValue: 'Zadnja spomladanska pozeba (-2 °C)' },
        { value: 'pozeba-2', viewValue: 'Prva jesenska pozeba (0 °C)' },
        { value: 'pozeba-3', viewValue: 'Prva jesenska pozeba (-2 °C)' },
        { value: 'pozeba-4', viewValue: 'Število dni s spomladansko pozebo (0 °C) za temperaturni prag 5 °C' },
        { value: 'pozeba-5', viewValue: 'Število dni s spomladansko pozebo (-2 °C) za temperaturni prag 5 °C' },
        { value: 'pozeba-6', viewValue: 'Število dni z jesensko pozebo (0 °C) za temperaturni prag 5 °C' },
        { value: 'pozeba-7', viewValue: 'Število dni z jesensko pozebo (-2 °C) za temperaturni prag 5 °C' },
        { value: 'pozeba-8', viewValue: 'Varnostna rezerva pred spomladansko pozebo (0 °C) za temperaturni prag 5 °C' },
        { value: 'pozeba-9', viewValue: 'Varnostna rezerva pred spomladansko pozebo (-2 °C) za temperaturni prag 5 °C' },
        { value: 'pozeba-10', viewValue: 'Varnostna rezerva pred jesensko pozebo (0 °C) za temperaturni prag 5 °C' },
        { value: 'pozeba-11', viewValue: 'Varnostna rezerva pred jesensko pozebo (-2 °C) za temperaturni prag 5 °C' }
      ];
      this.selectDisabled4 = true;
      this.selectDisabled5 = false;
      this.selectDisabled6 = true;
      this.hidden4 = false;
      this.hidden5 = true;
      this.hidden6 = false;
      this.selected5 = undefined;
      this.selected6 = undefined;
    }
    this.eventClicked3.emit(this.selected3);
    this.eventClicked4.emit(this.selected4);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked6.emit(this.selected6);
  }

  thirdaDropDownChanged(value: any) {
    console.log(value);

    if (value == 'tempPrag-3') {
      this.regija = [
        { value: 'reg-0', viewValue: 'Slovenija' },
        { value: 'reg-1', viewValue: 'Posočje' },
        { value: 'reg-2', viewValue: 'Osrednja' },
        { value: 'reg-3', viewValue: 'Severovzhod' },
        { value: 'reg-4', viewValue: 'Jugozahod' },
        { value: 'reg-6', viewValue: 'Prehodna' }
      ];
    } else {
      this.regija = [
        { value: 'reg-0', viewValue: 'Slovenija' },
        { value: 'reg-1', viewValue: 'Posočje' },
        { value: 'reg-2', viewValue: 'Osrednja' },
        { value: 'reg-3', viewValue: 'Severovzhod' },
        { value: 'reg-4', viewValue: 'Jugozahod' },
        { value: 'reg-5', viewValue: 'Visokogorje' },
        { value: 'reg-6', viewValue: 'Prehodna' }
      ]
    }
    this.selected4 = undefined;
    this.eventClicked4.emit(this.selected4);
  }

  thirdbDropDownChanged(value: any) {
    console.log(value);

    this.selected4 = undefined;
    this.eventClicked4.emit(this.selected4);
  }

  thirdcDropDownChanged(value: any) {
    console.log(value);

    this.selected4 = undefined;
    this.eventClicked4.emit(this.selected4);
  }

  fourthDropDownChanged(value: any) {
    console.log(value);
  }

  fifthDropDownChanged(value: any) {
    console.log(value);

    if (value == 'tmpTal-0' || value == 'tmpTal-1' || value == 'tmpTal-2' || value == 'tmpTal-3' || value == 'tmpTal-4' || value == 'tmpTal-5' || value == 'tmpTal-6' || value == 'tmpTal-7') {
      this.postaje = [
        { value: 'post-0', viewValue: 'Bilje' },
        { value: 'post-1', viewValue: 'Celje' },
        { value: 'post-2', viewValue: 'Ljubljana' },
        { value: 'post-3', viewValue: 'Novo mesto' },
        { value: 'post-4', viewValue: 'Maribor' },
        { value: 'post-5', viewValue: 'Murska Sobota' },
        { value: 'post-6', viewValue: 'Šmartno pri Slovenj Gradcu' }
      ];
      this.selectDisabled6 = false;
      this.hidden6 = true;
    }

    else if (value == 'feno-1') {
      this.postaje = [
        { value: 'post-1', viewValue: 'Celje' },
        { value: 'post-2', viewValue: 'Lesce' },
        { value: 'post-3', viewValue: 'Ljubljana' },
        { value: 'post-4', viewValue: 'Novo mesto' },
        { value: 'post-6', viewValue: 'Slovenske Konjice' },
        { value: 'post-7', viewValue: 'Starše' },
        { value: 'post-8', viewValue: 'Veliki Dolenci' }
      ];
      this.selectDisabled6 = false;
      this.hidden6 = true;
      this.selected6 = undefined;
    }
    else if (value == 'feno-2') {
      this.postaje = [
        { value: 'post-1', viewValue: 'Celje' },
        { value: 'post-2', viewValue: 'Lesce' },
        { value: 'post-3', viewValue: 'Ljubljana' },
        { value: 'post-4', viewValue: 'Novo mesto' },
        { value: 'post-6', viewValue: 'Slovenske Konjice' },
        { value: 'post-7', viewValue: 'Starše' }
      ];
      this.selectDisabled6 = false;
      this.hidden6 = true;
      this.selected6 = undefined;
    }
    else {
      this.postaje = [
        { value: 'post-0', viewValue: 'Bilje' },
        { value: 'post-1', viewValue: 'Celje' },
        { value: 'post-2', viewValue: 'Lesce' },
        { value: 'post-3', viewValue: 'Ljubljana' },
        { value: 'post-4', viewValue: 'Novo mesto' },
        { value: 'post-5', viewValue: 'Portorož' },
        { value: 'post-6', viewValue: 'Slovenske Konjice' },
        { value: 'post-7', viewValue: 'Starše' },
        { value: 'post-8', viewValue: 'Veliki Dolenci' }
      ];
      this.selectDisabled6 = false;
      this.hidden6 = true;
    }

    this.eventClicked5.emit(this.selected5);
    this.eventClicked6.emit(this.selected6);

  }

  sixthDropDownChanged(value: any) {
    console.log(value);
  }

  sixthaDropDownChanged(value: any) {
    console.log(value);
  }

  eigthDropDownChanged(value: any) {
    console.log(value);
  }

  eleventhDropDownChanged(value: any) {
    console.log(value);
  }

  eleventhcDropDownChanged(value: any) {
    console.log(value);
  }

  twelveDropDownChanged(value: any){
    console.log(value);
  } 

  thirteenDropDownChanged(value: any){
    console.log(value);
  } 

  @Output() eventClicked1 = new EventEmitter<Event>();
  @Output() eventClicked2 = new EventEmitter<Event>();
  @Output() eventClicked3 = new EventEmitter<Event>();
  @Output() eventClicked3a = new EventEmitter<Event>();
  @Output() eventClicked3b = new EventEmitter<Event>();
  @Output() eventClicked3c = new EventEmitter<Event>();
  @Output() eventClicked4 = new EventEmitter<Event>();
  @Output() eventClicked5 = new EventEmitter<Event>();
  @Output() eventClicked6 = new EventEmitter<Event>();
  @Output() eventClicked6a = new EventEmitter<Event>();
  @Output() eventClicked8 = new EventEmitter<Event>();
  @Output() eventClicked11 = new EventEmitter<Event>();
  @Output() eventClicked11c = new EventEmitter<Event>();
  @Output() eventClicked12 = new EventEmitter<Event>();
  @Output() eventClicked13 = new EventEmitter<Event>();

  constructor(private router: Router,
    private route: ActivatedRoute,
    private sidebarService: SidebarService) {
  }


  ngOnInit() {
  }

  onClick1(selected1: Event): void {
    this.eventClicked1.emit(selected1);
  }

  onClick2(selected2: Event): void {
    this.eventClicked2.emit(selected2);
  }

  onClick3(selected3: Event): void {
    this.eventClicked3.emit(selected3);
  }

  onClick3a(selected3a: Event): void {
    this.eventClicked3a.emit(selected3a);
  }

  onClick3b(selected3b: Event): void {
    this.eventClicked3b.emit(selected3b);
  }

  onClick3c(selected3c: Event): void {
    this.eventClicked3c.emit(selected3c);
  }

  onClick4(selected4: Event): void {
    this.eventClicked4.emit(selected4);
  }

  onClick5(selected5: Event): void {
    this.eventClicked5.emit(selected5);
  }

  onClick6(selected6: Event): void {
    this.eventClicked6.emit(selected6);
  }

  onClick6a(selected6a: Event): void {
    this.eventClicked6a.emit(selected6a);
  }

  onClick8(selected8: Event): void {
    this.eventClicked8.emit(selected8);
  }

  onClick11(selected11: Event): void {
    this.eventClicked11.emit(selected11);
  }

  onClick11c(selected11c: Event): void {
    this.eventClicked11c.emit(selected11c);
  }

  onClick12(selected12: Event): void {
    this.eventClicked12.emit(selected12);
  }

  onClick13(selected13: Event): void {
    this.eventClicked13.emit(selected13);
  }

}
